import React from 'react';
import { Sticky } from '@alfa-bank/site-sticky';
import cn from 'classnames';

import styles from '../../styles/styles.css';

import type { TStickyWrapper } from './models';

export const StickyWrapper = (props: TStickyWrapper) => {
    const {
        FeedbackFormSmart,
        elLocation = 'partly',
        targetSelectors = [],
        targetSelectorsForHide = [],
        ...rest
    } = props;

    return (
        <Sticky
            className={cn(styles.external, styles.sticky)}
            elLocation={elLocation}
            position="bottom"
            shadow={false}
            targetSelectors={targetSelectors}
            targetSelectorsForHide={targetSelectorsForHide}
        >
            <FeedbackFormSmart {...rest} />
        </Sticky>
    );
};
